import {ContainerModule} from '@yosmanyga/di'

import {ConfigManager} from './ConfigManager'
import {CredentialManager} from './CredentialManager'
import {DeviceManager} from './DeviceManager'
import {Dispatcher} from './Dispatcher'
import {LanguageManager} from './LanguageManager'
import {Translator} from './Translator'

const DI = new ContainerModule((bind) => {
    bind(ConfigManager).toSelf().inSingletonScope()
    bind(CredentialManager).toSelf().inSingletonScope()
    bind(DeviceManager).toSelf().inSingletonScope()
    bind(Dispatcher).toSelf().inSingletonScope()
    bind(LanguageManager).toSelf().inSingletonScope()
    bind(Translator).toSelf().inSingletonScope()
})

export {
    DI
}
